import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "card bg-white border-0 rounded-10 mb-25" };
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" };
const _hoisted_3 = { class: "d-flex align-items-center justify-content-between mb-25" };
const _hoisted_4 = { class: "d-flex align-items-center" };
const _hoisted_5 = { class: "mb-0 fw-bold" };
const _hoisted_6 = { class: "d-flex align-items-center gap-3" };
const _hoisted_7 = { class: "search-box position-relative" };
const _hoisted_8 = { class: "table-responsive" };
const _hoisted_9 = { class: "table align-middle custom-table" };
const _hoisted_10 = { class: "d-flex flex-column" };
const _hoisted_11 = { class: "fw-bold text-dark" };
const _hoisted_12 = { class: "text-muted small" };
const _hoisted_13 = { class: "d-flex flex-column" };
const _hoisted_14 = { class: "fw-bold text-dark" };
const _hoisted_15 = { class: "text-muted small" };
const _hoisted_16 = { class: "d-flex flex-column" };
const _hoisted_17 = { class: "fw-bold text-dark" };
const _hoisted_18 = { class: "text-muted small" };
const _hoisted_19 = { class: "d-flex flex-column gap-1" };
const _hoisted_20 = { class: "badge bg-light text-dark border w-auto align-self-start" };
const _hoisted_21 = { class: "fw-black text-primary fs-5" };
const _hoisted_22 = {
    key: 0,
    class: "bg-light px-2 py-1 rounded text-primary fw-bold border border-primary-subtle"
};
const _hoisted_23 = {
    key: 1,
    class: "text-muted small italic"
};
const _hoisted_24 = { class: "text-end" };
const _hoisted_25 = { class: "dropdown" };
const _hoisted_26 = { class: "dropdown-menu dropdown-menu-end border-0 shadow-sm p-2" };
const _hoisted_27 = ["onClick"];
const _hoisted_28 = { key: 0 };
const _hoisted_29 = ["onClick"];
const _hoisted_30 = { key: 1 };
const _hoisted_31 = ["onClick"];
const _hoisted_32 = { key: 0 };
const _hoisted_33 = { class: "modal-dialog modal-dialog-centered" };
const _hoisted_34 = { class: "modal-content border-0 shadow-lg rounded-4" };
const _hoisted_35 = { class: "modal-header border-bottom-0 pb-0 mt-2" };
const _hoisted_36 = { class: "modal-body py-4" };
const _hoisted_37 = {
    class: "bg-light p-4 rounded-4 text-dark fs-6",
    style: { "white-space": "pre-wrap", "line-height": "1.6" }
};
const _hoisted_38 = { class: "modal-footer border-top-0 pt-0 mb-2" };
const _hoisted_39 = { class: "modal-dialog modal-dialog-centered" };
const _hoisted_40 = { class: "modal-content border-0 shadow-lg rounded-4" };
const _hoisted_41 = { class: "modal-header border-bottom-0 pb-0 mt-2" };
const _hoisted_42 = { class: "modal-body py-4" };
const _hoisted_43 = { class: "d-flex align-items-center mb-3" };
const _hoisted_44 = { class: "fs-6 text-muted mb-0" };
const _hoisted_45 = { class: "modal-footer border-top-0 pt-0 mb-2" };
const _hoisted_46 = ["disabled"];
const _hoisted_47 = ["disabled"];
const _hoisted_48 = {
    key: 0,
    class: "spinner-border spinner-border-sm",
    role: "status",
    "aria-hidden": "true"
};
const _hoisted_49 = { class: "modal-dialog modal-dialog-centered" };
const _hoisted_50 = { class: "modal-content border-0 shadow-lg rounded-4" };
const _hoisted_51 = { class: "modal-header border-bottom-0 pb-0 mt-2" };
const _hoisted_52 = { class: "modal-body py-4" };
const _hoisted_53 = { class: "d-flex align-items-center mb-3" };
const _hoisted_54 = { class: "fs-6 text-muted mb-0" };
const _hoisted_55 = { class: "modal-footer border-top-0 pt-0 mb-2" };
const _hoisted_56 = ["disabled"];
const _hoisted_57 = ["disabled"];
const _hoisted_58 = {
    key: 0,
    class: "spinner-border spinner-border-sm",
    role: "status",
    "aria-hidden": "true"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _cache[16] || (_cache[16] = _createElementVNode("i", { class: "flaticon-gift-card fs-2 text-primary me-2" }, null, -1)),
                    _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.$t('sidebar.giftCards')), 1)
                ]),
                _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                        _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            placeholder: "Rechercher une carte...",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.searchQuery) = $event))
                        }, null, 512), [
                            [_vModelText, _ctx.searchQuery]
                        ]),
                        _cache[17] || (_cache[17] = _createElementVNode("i", { class: "flaticon-search-interface-symbol position-absolute start-0 top-50 translate-middle-y ms-15 text-muted" }, null, -1))
                    ]),
                    _createElementVNode("button", {
                        onClick: _cache[1] || (_cache[1] =
                            //@ts-ignore
                            (...args) => (_ctx.fetchGiftCards && _ctx.fetchGiftCards(...args))),
                        class: "btn btn-outline-primary px-4 rounded-pill"
                    }, [...(_cache[18] || (_cache[18] = [
                            _createElementVNode("i", { class: "flaticon-refresh me-1" }, null, -1),
                            _createTextVNode(" Actualiser ", -1)
                        ]))])
                ])
            ]),
            _createElementVNode("div", _hoisted_8, [
                _createElementVNode("table", _hoisted_9, [
                    _cache[24] || (_cache[24] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "Date"),
                            _createElementVNode("th", null, "Expéditeur"),
                            _createElementVNode("th", null, "Destinataire"),
                            _createElementVNode("th", null, "Type / Format"),
                            _createElementVNode("th", null, "Montant"),
                            _createElementVNode("th", null, "Statut"),
                            _createElementVNode("th", null, "Code Coupon"),
                            _createElementVNode("th", { class: "text-end" }, "Actions")
                        ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredCards, (card) => {
                            return (_openBlock(), _createElementBlock("tr", {
                                key: card.id
                            }, [
                                _createElementVNode("td", null, [
                                    _createElementVNode("div", _hoisted_10, [
                                        _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.formatDate(card.created_at)), 1),
                                        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.formatTime(card.created_at)), 1)
                                    ])
                                ]),
                                _createElementVNode("td", null, [
                                    _createElementVNode("div", _hoisted_13, [
                                        _createElementVNode("span", _hoisted_14, _toDisplayString(card.senderName), 1),
                                        _createElementVNode("span", _hoisted_15, _toDisplayString(card.senderEmail), 1)
                                    ])
                                ]),
                                _createElementVNode("td", null, [
                                    _createElementVNode("div", _hoisted_16, [
                                        _createElementVNode("span", _hoisted_17, _toDisplayString(card.recipientName || card.senderName), 1),
                                        _createElementVNode("span", _hoisted_18, _toDisplayString(card.recipientEmail || card.senderEmail), 1)
                                    ])
                                ]),
                                _createElementVNode("td", null, [
                                    _createElementVNode("div", _hoisted_19, [
                                        _createElementVNode("span", _hoisted_20, _toDisplayString(card.purchaseType === 'SELF' ? 'Pour soi' : 'Offert'), 1),
                                        _createElementVNode("span", {
                                            class: _normalizeClass(["badge w-auto align-self-start", card.formatType === 'PHYSICAL' ? 'bg-secondary' : 'bg-info'])
                                        }, _toDisplayString(card.formatType === 'PHYSICAL' ? 'Physique' : 'Digitale'), 3)
                                    ])
                                ]),
                                _createElementVNode("td", null, [
                                    _createElementVNode("span", _hoisted_21, _toDisplayString(card.amount) + " CHF", 1)
                                ]),
                                _createElementVNode("td", null, [
                                    _createElementVNode("span", {
                                        class: _normalizeClass(["badge px-3 py-2 rounded-pill", _ctx.getStatusClass(card.status)])
                                    }, _toDisplayString(_ctx.getStatusLabel(card.status)), 3)
                                ]),
                                _createElementVNode("td", null, [
                                    (card.couponId)
                                        ? (_openBlock(), _createElementBlock("code", _hoisted_22, _toDisplayString(card.couponId), 1))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_23, "N/A"))
                                ]),
                                _createElementVNode("td", _hoisted_24, [
                                    _createElementVNode("div", _hoisted_25, [
                                        _cache[22] || (_cache[22] = _createElementVNode("button", {
                                            class: "btn btn-light btn-sm rounded-circle p-2",
                                            type: "button",
                                            "data-bs-toggle": "dropdown",
                                            "aria-expanded": "false"
                                        }, [
                                            _createElementVNode("i", { class: "flaticon-dots" })
                                        ], -1)),
                                        _createElementVNode("ul", _hoisted_26, [
                                            _createElementVNode("li", null, [
                                                _createElementVNode("button", {
                                                    class: "dropdown-item rounded-3 mb-1",
                                                    onClick: ($event) => (_ctx.viewDetails(card))
                                                }, [...(_cache[19] || (_cache[19] = [
                                                        _createElementVNode("i", { class: "flaticon-view me-2" }, null, -1),
                                                        _createTextVNode(" Voir détails ", -1)
                                                    ]))], 8, _hoisted_27)
                                            ]),
                                            (card.status === 'PENDING')
                                                ? (_openBlock(), _createElementBlock("li", _hoisted_28, [
                                                    _createElementVNode("button", {
                                                        class: "dropdown-item rounded-3 text-success",
                                                        onClick: ($event) => (_ctx.markAsPaid(card))
                                                    }, [...(_cache[20] || (_cache[20] = [
                                                            _createElementVNode("i", { class: "flaticon-check me-2" }, null, -1),
                                                            _createTextVNode(" Marquer comme payé ", -1)
                                                        ]))], 8, _hoisted_29)
                                                ]))
                                                : _createCommentVNode("", true),
                                            (card.status === 'PENDING_ACTIVATION')
                                                ? (_openBlock(), _createElementBlock("li", _hoisted_30, [
                                                    _createElementVNode("button", {
                                                        class: "dropdown-item rounded-3 text-primary fw-bold",
                                                        onClick: ($event) => (_ctx.activatePhysical(card))
                                                    }, [...(_cache[21] || (_cache[21] = [
                                                            _createElementVNode("i", { class: "flaticon-power-button me-2" }, null, -1),
                                                            _createTextVNode(" Activer (Remise au client) ", -1)
                                                        ]))], 8, _hoisted_31)
                                                ]))
                                                : _createCommentVNode("", true)
                                        ])
                                    ])
                                ])
                            ]));
                        }), 128)),
                        (_ctx.filteredCards.length === 0)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_32, [...(_cache[23] || (_cache[23] = [
                                    _createElementVNode("td", {
                                        colspan: "7",
                                        class: "text-center py-5"
                                    }, [
                                        _createElementVNode("div", { class: "d-flex flex-column align-items-center" }, [
                                            _createElementVNode("i", {
                                                class: "flaticon-gift-card fs-1 text-light mb-3",
                                                style: { "font-size": "80px !important" }
                                            }),
                                            _createElementVNode("p", { class: "text-muted fs-5" }, "Aucune carte cadeau trouvée")
                                        ])
                                    ], -1)
                                ]))]))
                            : _createCommentVNode("", true)
                    ])
                ])
            ])
        ]),
        (_ctx.showDetailsModal)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "modal-backdrop fade show",
                onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.showDetailsModal = false))
            }))
            : _createCommentVNode("", true),
        (_ctx.showDetailsModal)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "modal fade show d-block",
                tabindex: "-1",
                onClick: _cache[5] || (_cache[5] = _withModifiers(($event) => (_ctx.showDetailsModal = false), ["self"]))
            }, [
                _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                            _cache[25] || (_cache[25] = _createElementVNode("h5", { class: "modal-title fw-bold fs-4" }, "Détails du message", -1)),
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn-close",
                                onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.showDetailsModal = false))
                            })
                        ]),
                        _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.selectedCard?.message || 'Aucun message'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-primary px-4 py-2 rounded-pill fw-bold",
                                onClick: _cache[4] || (_cache[4] = ($event) => (_ctx.showDetailsModal = false))
                            }, "Fermer")
                        ])
                    ])
                ])
            ]))
            : _createCommentVNode("", true),
        (_ctx.showPaymentModal)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "modal-backdrop fade show",
                onClick: _cache[6] || (_cache[6] = ($event) => (_ctx.showPaymentModal = false))
            }))
            : _createCommentVNode("", true),
        (_ctx.showPaymentModal)
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                class: "modal fade show d-block",
                tabindex: "-1",
                onClick: _cache[10] || (_cache[10] = _withModifiers(($event) => (_ctx.showPaymentModal = false), ["self"]))
            }, [
                _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                            _cache[26] || (_cache[26] = _createElementVNode("h5", { class: "modal-title fw-bold fs-4 text-success" }, "Confirmer le paiement", -1)),
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn-close",
                                onClick: _cache[7] || (_cache[7] = ($event) => (_ctx.showPaymentModal = false))
                            })
                        ]),
                        _createElementVNode("div", _hoisted_42, [
                            _createElementVNode("div", _hoisted_43, [
                                _cache[33] || (_cache[33] = _createElementVNode("div", { class: "bg-success-subtle text-success p-3 rounded-circle me-3" }, [
                                    _createElementVNode("i", { class: "flaticon-check fs-2" })
                                ], -1)),
                                _createElementVNode("p", _hoisted_44, [
                                    _cache[27] || (_cache[27] = _createTextVNode("Confirmer le paiement de ", -1)),
                                    _createElementVNode("strong", null, _toDisplayString(_ctx.selectedCard?.amount) + " CHF", 1),
                                    _cache[28] || (_cache[28] = _createTextVNode(" pour la carte cadeau de ", -1)),
                                    _createElementVNode("strong", null, _toDisplayString(_ctx.selectedCard?.recipientName || _ctx.selectedCard?.senderName), 1),
                                    _cache[29] || (_cache[29] = _createTextVNode(" ? ", -1)),
                                    _cache[30] || (_cache[30] = _createElementVNode("br", null, null, -1)),
                                    _cache[31] || (_cache[31] = _createElementVNode("br", null, null, -1)),
                                    _cache[32] || (_cache[32] = _createTextVNode("Cela générera le code coupon et enverra l'e-mail immédiatement (sauf si physique).", -1))
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_45, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-light px-4 py-2 rounded-pill fw-bold",
                                onClick: _cache[8] || (_cache[8] = ($event) => (_ctx.showPaymentModal = false)),
                                disabled: _ctx.isConfirming
                            }, "Annuler", 8, _hoisted_46),
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-success px-4 py-2 rounded-pill fw-bold d-flex align-items-center gap-2",
                                onClick: _cache[9] || (_cache[9] =
                                    //@ts-ignore
                                    (...args) => (_ctx.confirmPayment && _ctx.confirmPayment(...args))),
                                disabled: _ctx.isConfirming
                            }, [
                                (_ctx.isConfirming)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_48))
                                    : _createCommentVNode("", true),
                                _cache[34] || (_cache[34] = _createTextVNode(" Oui, valider le paiement ", -1))
                            ], 8, _hoisted_47)
                        ])
                    ])
                ])
            ]))
            : _createCommentVNode("", true),
        (_ctx.showActivationModal)
            ? (_openBlock(), _createElementBlock("div", {
                key: 4,
                class: "modal-backdrop fade show",
                onClick: _cache[11] || (_cache[11] = ($event) => (_ctx.showActivationModal = false))
            }))
            : _createCommentVNode("", true),
        (_ctx.showActivationModal)
            ? (_openBlock(), _createElementBlock("div", {
                key: 5,
                class: "modal fade show d-block",
                tabindex: "-1",
                onClick: _cache[15] || (_cache[15] = _withModifiers(($event) => (_ctx.showActivationModal = false), ["self"]))
            }, [
                _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("div", _hoisted_51, [
                            _cache[35] || (_cache[35] = _createElementVNode("h5", { class: "modal-title fw-bold fs-4 text-primary" }, "Activer la carte physique", -1)),
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn-close",
                                onClick: _cache[12] || (_cache[12] = ($event) => (_ctx.showActivationModal = false))
                            })
                        ]),
                        _createElementVNode("div", _hoisted_52, [
                            _createElementVNode("div", _hoisted_53, [
                                _cache[42] || (_cache[42] = _createElementVNode("div", { class: "bg-primary-subtle text-primary p-3 rounded-circle me-3" }, [
                                    _createElementVNode("i", { class: "flaticon-power-button fs-2" })
                                ], -1)),
                                _createElementVNode("p", _hoisted_54, [
                                    _cache[36] || (_cache[36] = _createTextVNode("Vous êtes sur le point d'activer la carte physique pour ", -1)),
                                    _createElementVNode("strong", null, _toDisplayString(_ctx.selectedCard?.recipientName || _ctx.selectedCard?.senderName), 1),
                                    _cache[37] || (_cache[37] = _createTextVNode(" d'une valeur de ", -1)),
                                    _createElementVNode("strong", null, _toDisplayString(_ctx.selectedCard?.amount) + " CHF", 1),
                                    _cache[38] || (_cache[38] = _createTextVNode(".", -1)),
                                    _cache[39] || (_cache[39] = _createElementVNode("br", null, null, -1)),
                                    _cache[40] || (_cache[40] = _createElementVNode("br", null, null, -1)),
                                    _cache[41] || (_cache[41] = _createTextVNode("Généralement, cette action est faite lorsque vous remettez la carte physique en main propre au client.", -1))
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_55, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-light px-4 py-2 rounded-pill fw-bold",
                                onClick: _cache[13] || (_cache[13] = ($event) => (_ctx.showActivationModal = false)),
                                disabled: _ctx.isConfirming
                            }, "Annuler", 8, _hoisted_56),
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-primary px-4 py-2 rounded-pill fw-bold d-flex align-items-center gap-2",
                                onClick: _cache[14] || (_cache[14] =
                                    //@ts-ignore
                                    (...args) => (_ctx.confirmActivation && _ctx.confirmActivation(...args))),
                                disabled: _ctx.isConfirming
                            }, [
                                (_ctx.isConfirming)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_58))
                                    : _createCommentVNode("", true),
                                _cache[43] || (_cache[43] = _createTextVNode(" Activer maintenant ", -1))
                            ], 8, _hoisted_57)
                        ])
                    ])
                ])
            ]))
            : _createCommentVNode("", true)
    ]));
}
